module.exports = __webpack_public_path__ + "img/trip-history.93e0a76f.svg";